// using module.exports here so gatsby-config can read it
module.exports = {
  // TODO: uncomment next line and enter your own public API key
  builderAPIKey: 'c2a014bddb2344b59a1caedc2016a92c'
};
